module.exports = __webpack_public_path__ + "static/media/university-deferment.abc99a2d.jpg";